import React from 'react';
import { string, number } from 'prop-types';

import * as helpers from './helpers';

const ArrowBackIcon = ({ color, fillOpacity, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} {...props}>
    <path
      fill={color}
      fillOpacity={fillOpacity}
      d="M16.9882 6.58846L17.0163 6.59461H4.97152L8.75795 2.79983C8.94337 2.61456 9.04508 2.36358 9.04508 2.10017C9.04508 1.83676 8.94337 1.58754 8.75795 1.40183L8.16878 0.812365C7.98352 0.627097 7.73664 0.524658 7.47337 0.524658C7.20996 0.524658 6.96293 0.626366 6.77766 0.811634L0.28698 7.30173C0.10098 7.48773 -0.000727787 7.73549 3.92069e-06 7.99905C-0.000727787 8.26407 0.10098 8.51197 0.28698 8.69768L6.77766 15.1884C6.96293 15.3735 7.20981 15.4753 7.47337 15.4753C7.73664 15.4753 7.98352 15.3733 8.16878 15.1884L8.75795 14.5989C8.94337 14.4139 9.04508 14.1669 9.04508 13.9035C9.04508 13.6402 8.94337 13.4062 8.75795 13.2211L4.92878 9.4051H17.0017C17.5442 9.4051 18 8.93754 18 8.39534V7.56163C18 7.01944 17.5307 6.58846 16.9882 6.58846Z"
    />
  </svg>
);

ArrowBackIcon.propTypes = {
  fillOpacity: number,
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ArrowBackIcon.defaultProps = {
  fillOpacity: 0.4,
  ...helpers.getDefaultIconDimensionsProps(18, 16),
};

export default ArrowBackIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/arrow-back.js